<template>
  <div class="collapse d-md-block me-auto" id="top-navbar">
    <div class="navbar-nav">
      <div class="navbar-item dropdown dropdown-lg">
        <a
          href="#"
          class="navbar-link dropdown-toggle d-flex align-items-center"
          data-bs-toggle="dropdown"
        >
          <i class="fa fa-th-large fa-fw me-1 text-theme"></i>
          <span class="d-lg-inline d-md-none">Filtros</span>
        </a>
        <div
          class="dropdown-menu dropdown-menu-lg text-gray-900"
          @click.native.stop
        >
          <div class="row">
            <div class="col">
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <a
                    href="#tab-general"
                    data-bs-toggle="tab"
                    class="nav-link active me-2"
                  >
                    <span class="d-sm-none">Tab 1</span>
                    <span class="d-sm-block d-none">General</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="#tab-cliente"
                    data-bs-toggle="tab"
                    class="nav-link me-2"
                  >
                    <span class="d-sm-none">Tab 2</span>
                    <span class="d-sm-block d-none">Cliente</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="#tab-control"
                    data-bs-toggle="tab"
                    class="nav-link me-2"
                  >
                    <span class="d-sm-none">Tab 3</span>
                    <span class="d-sm-block d-none">Control</span>
                  </a>
                </li>
              </ul>

              <div class="tab-content panel rounded-0 p-3 m-0">
                <div class="tab-pane fade active show" id="tab-general">
                  <General />
                </div>
                <div class="tab-pane fade" id="tab-cliente">
                  <Cliente
                    @customers-form-updated="handleCustomersFormUpdate"
                  />
                </div>
                <div class="tab-pane fade" id="tab-control">
                  <Control />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import General from "@/components/_common/forms/General.vue";
import Cliente from "@/components/_common/forms/Cliente.vue";
import Control from "@/components/_common/forms/Control.vue";

const generalData = ref(null);
const clienteData = ref(null);
const controlData = ref(null);

const emit = defineEmits(["filters-updated"]);

const handleCustomersFormUpdate = (data: any) => {
  clienteData.value = data;
  emitFormData();
};

const emitFormData = () => {
  emit("filters-updated", {
    general: generalData.value,
    cliente: clienteData.value,
    control: controlData.value,
  });
};
</script>
